import(/* webpackMode: "eager", webpackExports: ["CookieGate"] */ "/home/interim/frontend/app/components/CookieGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/interim/frontend/app/components/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/interim/frontend/app/globals.css");
;
import(/* webpackMode: "eager" */ "/home/interim/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/interim/frontend/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
